import { useMutation } from '@apollo/client'
import {
  RemoveAudienceMemberV2Mutation,
  RemoveAudienceMemberV2MutationVariables
} from '../../data/gql-gen/questionnaire/graphql'
import { REMOVE_AUDIENCE_MEMBER_V2 } from '../../data/gql/questionnaire/mutations/removeAudienceMemberV2'
import { audienceQuestionLogicRefetchQueries } from '../../data/gql/questionnaire/queries/audienceQuestionLogic'
import { draftAudienceRefetchQuery } from '../../data/gql/questionnaire/queries/audiences'
import { categoriesRefetchQuery } from '../../data/gql/questionnaire/queries/categories'
import { customCriteriaRefetchQuery } from '../../data/gql/questionnaire/queries/customCriteria'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useOptionalWaveId } from '../useOptionalWaveId'
import { useProjectId } from '../useProjectId'
import { useSurveyId } from '../useSurveyId'

export const useRemoveAudienceMemberV2 = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()
  const waveId = useOptionalWaveId()
  const [removeAudienceMemberV2Mutation] = useMutation<
    RemoveAudienceMemberV2Mutation,
    RemoveAudienceMemberV2MutationVariables
  >(REMOVE_AUDIENCE_MEMBER_V2, {
    context: { clientName: 'questionnaire' },
    onError(error) {
      captureApolloError(
        LoggerErrorType.ApolloMutation,
        'removeAudienceMemberV2',
        error
      )
    },
    refetchQueries: [
      draftAudienceRefetchQuery(projectId, surveyId, waveId),
      customCriteriaRefetchQuery(projectId, surveyId, waveId),
      categoriesRefetchQuery(projectId, surveyId, waveId),
      ...audienceQuestionLogicRefetchQueries(projectId, surveyId, waveId)
    ]
  })

  const removeAudienceMemberV2 = (memberId: string) => {
    removeAudienceMemberV2Mutation({
      variables: {
        input: {
          projectId,
          surveyId,
          waveId,
          memberId
        }
      }
    })
  }

  return removeAudienceMemberV2
}
